module.exports = __webpack_public_path__ + "img/cases-brand-hla-4.276d83dc.png";